'use strict';

export default (store) => {
  return (to, from, next) => {
    if (to.name === 'overview') {
      if (store.getters['auth/hasSomeRole'](['DEALER', 'DEALER_L2'])) {
        return next();
      } else if (store.getters['auth/hasRole']('ADMIN')) {
        return next('/users');
      } else if (store.getters['auth/hasRole']('DRIVER')) {
        return next('/orders');
      }
    }
    next();
  }
};



// WEBPACK FOOTER //
// ./client/router/hooks/overviewHook.js